import appVariables from '@/config'
import { getCloudflareImageUrl } from '@fusion/media/cloudflare'
import { Avatar, CardMedia, Stack, Tooltip } from '@mui/material'
import NoImageAvailable from '@public/images/no-image-available.png'

import React from 'react'
import { useInView } from 'react-intersection-observer'

export type ItemCardMediaProps = {
  imageUrl?: string | null
  imageTitle?: string | null
  vendorName?: string | null
  vendorAvatar?: string | null
}

const ItemCardMedia: React.FC<ItemCardMediaProps> = ({
  imageTitle,
  imageUrl,
  vendorName,
  vendorAvatar,
}) => {
  const { ref, inView } = useInView({
    triggerOnce: true,
  })
  const url = imageUrl
    ? getCloudflareImageUrl({
        enabled: appVariables.CLOUDFLARE_OPTIMISE_IMAGE,
        src: imageUrl,
        width: 500,
        quality: 100,
      })
    : NoImageAvailable.src
  const avatarUrl = getCloudflareImageUrl({
    enabled: appVariables.CLOUDFLARE_OPTIMISE_IMAGE,
    src: vendorAvatar || '',
    width: 100,
    quality: 100,
  })

  const title = imageTitle || ''
  return (
    <CardMedia
      sx={{ height: '100%', minHeight: 160 }}
      image={inView ? url : ''}
      title={title}
      ref={ref}>
      {vendorAvatar && vendorName ? (
        <Stack padding={1} height="100%" direction="column-reverse">
          <Tooltip title={vendorName}>
            <Avatar sx={{ width: 44, height: 44 }} alt={vendorName} src={inView ? avatarUrl : ''}>
              &nbsp;
            </Avatar>
          </Tooltip>
        </Stack>
      ) : null}
    </CardMedia>
  )
}

export default ItemCardMedia
